import {StickyRichLabelData} from '@gongxigames/framework/slot/modules/watermark';

export const WaterMarkComponentsConfigDesktop: Record<string, StickyRichLabelData> = {
    globalTimeClock: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'globalClockContainer',
        labelContainerName: 'labelClockContainer',
        stickyPosition: 'bottom-right'
    },
    elapsedTimeClock: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'clockContainer',
        labelContainerName: 'labelClockContainer',
        stickyPosition: 'bottom-right'
    },
    sessionBalance: {
        id: 'netPositionBalance',
        style: 'watermark_desktop',
        sourceContainerName: 'balanceContainer',
        labelContainerName: 'labelBalanceContainer',
        stickyPosition: 'none'
    },
    maxWinProbability: {
        id: 'maxWinProbability',
        style: 'maxProbabilityDesktop',
        sourceContainerName: 'maxWinProbabilityContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'none'
    },
    RTPWatermark: {
        id: 'RTPWatermark',
        style: 'RTPWatermarkDesktop',
        sourceContainerName: 'RTPContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'bottom-right',
        hasBackground: true
    },
    gameName: {
        id: 'watermark',
        style: 'watermark_desktop',
        sourceContainerName: 'gameNameContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'bottom-right'
    },
    sessionEarnings: {
        id: 'sessionEarnings',
        style: 'watermark_desktop',
        sourceContainerName: 'sessionEarningsContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'none'
    },
    sessionBets: {
        id: 'sessionBets',
        style: 'watermark_desktop',
        sourceContainerName: 'sessionBetsContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'none'
    }
};

export const WaterMarkComponentsConfigLandscape: Record<string, StickyRichLabelData> = {
    globalTimeClock: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'globalClockContainer',
        labelContainerName: 'labelClockContainer'
    },
    globalTimeClock_pure: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'globalClockContainer_pure',
        labelContainerName: 'labelClockContainer',
        stickyPosition: 'top-right'
    },
    elapsedTimeClock: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'clockContainer',
        labelContainerName: 'labelClockContainer'
    },
    sessionBalance: {
        id: 'netPositionBalanceLandscape',
        style: 'netPositionBalanceLandscape',
        sourceContainerName: 'balanceContainer',
        labelContainerName: 'labelBalanceContainer'
    },
    maxWinProbability: {
        id: 'maxWinProbabilityLandscape',
        style: 'maxProbabilityLandscape',
        sourceContainerName: 'maxWinProbabilityContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'right',
        hasBackground: true
    },
    RTPWatermark: {
        id: 'RTPWatermark',
        style: 'RTPWatermarkLandscape',
        sourceContainerName: 'RTPContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'top-right',
        hasBackground: true
    },
    gameName: {
        id: 'watermark',
        style: 'watermark_mobile',
        sourceContainerName: 'gameNameContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'top-left',
        hasBackground: true
    },
    sessionEarnings: {
        id: 'sessionEarningsLandscape',
        style: 'netPositionBalanceLandscape',
        sourceContainerName: 'sessionEarningsContainer',
        labelContainerName: 'labelContainer'
    },
    sessionBets: {
        id: 'sessionBetsLandscape',
        style: 'netPositionBalanceLandscape',
        sourceContainerName: 'sessionBetsContainer',
        labelContainerName: 'labelContainer'
    }
};

export const WaterMarkComponentsConfigPortrait: Record<string, StickyRichLabelData> = {
    globalTimeClock: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'globalClockContainer',
        labelContainerName: 'labelClockContainer',
        stickyPosition: 'top-right'
    },
    elapsedTimeClock: {
        id: 'elapsedTimeClock',
        style: 'elapsedTimeClock',
        sourceContainerName: 'clockContainer',
        labelContainerName: 'labelClockContainer',
        stickyPosition: 'top-right'
    },
    sessionBalance: {
        id: 'netPositionBalance',
        style: 'netPositionBalancePortrait',
        sourceContainerName: 'balanceContainer',
        labelContainerName: 'labelBalanceContainer',
        stickyPosition: 'bottom'
    },
    maxWinProbability: {
        id: 'maxWinProbability',
        style: 'maxProbabilityPortrait',
        sourceContainerName: 'maxWinProbabilityContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'bottom',
        hasBackground: true
    },
    RTPWatermark: {
        id: 'RTPWatermark',
        style: 'RTPWatermarkPortrait',
        sourceContainerName: 'RTPContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'top-right',
        hasBackground: true
    },
    gameName: {
        id: 'watermark',
        style: 'watermark_mobile_portrait',
        sourceContainerName: 'gameNameContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'top-left',
        hasBackground: true
    },
    sessionEarnings: {
        id: 'sessionEarnings',
        style: 'netPositionBalanceDesktop',
        sourceContainerName: 'sessionEarningsContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'bottom-left'
    },
    sessionBets: {
        id: 'sessionBets',
        style: 'netPositionBalanceLandscape',
        sourceContainerName: 'sessionBetsContainer',
        labelContainerName: 'labelContainer',
        stickyPosition: 'bottom-right'
    }
};
